import { IonAlert, IonContent, IonIcon, IonItem, IonItemOption, IonItemOptions, IonItemSliding, IonLabel } from '@ionic/react'
import { createOutline, trashOutline } from 'ionicons/icons'
import { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { startEquipoUpdated } from '../../../actions/equipos'
import { setActiveLoading, setCapacidadEditHide, setCapacidadEditShow } from '../../../actions/ui'
import { RootState } from '../../../reducers/rootReducer'

export const CapacidadItem: FC = () => {
  const dispatch = useDispatch();
  const { activeEquipo: { capacidad } } = useSelector((state: RootState) => state.equipo);
  const { editCapacidad } = useSelector((state: RootState) => state.ui);

  const handleDelete = () => {}
  const handleUpdate = () => {
    dispatch(setCapacidadEditShow())

  }
  return (
    <IonItem>
      <IonLabel className="item-label" position="stacked" color="primary">
        Capacidad
      </IonLabel>
      <IonItemSliding>
        <IonItem lines="none">
          <IonLabel>{capacidad}</IonLabel>
          {editCapacidad && <CapacidadModal />}
        </IonItem>
        <IonItemOptions side="end" color="light">
          <IonItemOption color="light" onClick={() => { handleUpdate() }}><IonIcon className="icon-list" color="success" ariaLabel="Editar" title="Editar" icon={createOutline}></IonIcon></IonItemOption>
          <IonItemOption color="light" onClick={() => { handleDelete() }}><IonIcon className="icon-list" color="danger" icon={trashOutline}></IonIcon></IonItemOption>
        </IonItemOptions>
      </IonItemSliding>
    </IonItem>
  )
}

const CapacidadModal: FC = () => {
  const dispatch = useDispatch();
  const { editCapacidad } = useSelector((state: RootState) => state.ui);
  const { activeEquipo } = useSelector((state: RootState) => state.equipo);

  const equipo = {
    tag: activeEquipo.tag,
    nombre_equipo: activeEquipo.nombre_equipo,
    descripcion_equipo: activeEquipo.descripcion_equipo,
    central: activeEquipo.central !== null ? activeEquipo.central._id : "",
    numero_equipo: activeEquipo.numero_equipo,
    type: activeEquipo.type,
    capacidad: activeEquipo.capacidad
  }
  const { capacidad } = activeEquipo;

  const handleUpdate = ({ name }) => {
    dispatch(setActiveLoading());
    equipo.capacidad = name
    dispatch(startEquipoUpdated(equipo));
    dispatch(setCapacidadEditHide())
  };

  const handleClose = () => {
    dispatch(setCapacidadEditHide());
  };
  return (
    <IonContent>
      <IonAlert
        isOpen={editCapacidad}
        onDidDismiss={handleClose}
        header={'Capacidad'}
        inputs={[
          {
            name: 'name',
            type: 'text',
            placeholder: 'Capacidad',
            value: capacidad
          },
        ]}
        buttons={[
          {
            text: 'Guardar',
            handler: (e) => {
              handleUpdate(e);
            }
          },
          {
            text: 'Cancelar',
            role: 'cancel',
            cssClass: 'secondary',
            handler: () => {}
          }
        ]}
      />
    </IonContent>
  );
}
